import { WidgetConfig } from '@helo/cms'

import { WidgetRenderer2 } from '../WidgetRenderer/WidgetRenderer2'
import { createWidget } from '../widget-utils'

export type ConditionalWidgetProps = {
  condition1?: string
  condition2?: string
  widget1?: WidgetConfig
  widget2?: WidgetConfig
}
export const ConditionalWidget = ({
  condition1,
  condition2,
  widget1,
  widget2,
}: ConditionalWidgetProps) => {
  return (
    <WidgetRenderer2
      widgetConfig={condition1 === condition2 ? widget1 : widget2}
    />
  )
}

export const ConditionalWidgetDefinition = createWidget(ConditionalWidget, {
  type: 'Conditional',
  slots: [],
})
